/* @flow */

import React from "react";
import { ButtonLink } from "@crossroads/ui-components";
import styles from "./styles.scss";

export type Image = {
  dataUrl?: string,
  url: string,
  media: string,
};

type Slide = {
  +heading?: string,
  +description?: string,
  +button: {
    +text?: string,
    +link?: string,
    +externalLink?: string,
  },
  +images: Array<Image>,
};

type Props = {
  data: Slide,
};

const Hero = ({ data }: Props): React$Node => {
  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.text}>
          {data.heading !== undefined && (
            <h2 className={styles.heading}>
              {data.heading}
            </h2>
          )}
          {data.description !== undefined && (
            <p className={styles.description}>
              {data.description}
            </p>
          )}
          <div>
            {data.button.text && data.button.link && (
              <ButtonLink
                to={data.button.link}
                variant="primary"
              >
                {data.button.text || ""}
              </ButtonLink>
            )}

            {data.button.text && data.button.externalLink && (
              <ButtonLink
                to={data.button.externalLink}
                variant="primary"
              >
                {data.button.text || ""}
              </ButtonLink>
            )}
          </div>
        </div>
      </div>
      <picture className={styles.media}>
        {data.images.map((source, i) => (
          <source key={i} srcSet={source.url} media={source.media} />
        ))}

        {data.images.length > 0 && (
          <img
            draggable="false"
            src={data.images[0].dataUrl || data.images[0].url}
            className={styles.image}
            alt={data.heading}
          />
        )}
      </picture>
    </div>
  );
};

export default Hero;
